import React from "react";
//import '../index.css'; 
import { BarChartLineFill, BookFill, Mortarboard, PersonLinesFill } from 'react-bootstrap-icons';
import { Link } from "react-router-dom";
import { 
  LaptopFill, 
  PhoneFill, 
  GearFill, 
  CloudFill, 
  ShieldLockFill, 
  LightbulbFill 
} from "react-bootstrap-icons";



// Define your icons and text in an array
const icons = [
  { 
    id: 1,
    icon: <LaptopFill size={24} color="rgb(234, 181, 112)" />, 
    title: "Web Application Development",
    text: "We design and build fast, secure, and scalable web applications tailored to your business needs using modern technologies like React, Node.js, and MongoDB."
  },

  { 
    id: 2,
    icon: <PhoneFill size={24} color="rgb(234, 181, 112)" />, 
    title: "Mobile App Development",
    text: "We create intuitive and user-friendly Android and iOS mobile apps that deliver seamless experiences and solve real-world business problems."
  },

  { 
    id: 3,
    icon: <GearFill size={24} color="rgb(234, 181, 112)" />, 
    title: "API & Backend Development",
    text: "We develop robust backend systems and RESTful APIs that ensure your applications run smoothly, securely, and efficiently."
  },

  { 
    id: 4,
    icon: <CloudFill size={24} color="rgb(234, 181, 112)" />, 
    title: "Cloud & DevOps Services",
    text: "We deploy and manage cloud solutions using AWS, Azure, or DigitalOcean, implementing CI/CD pipelines for reliability and scalability."
  },

  { 
    id: 5,
    icon: <ShieldLockFill size={24} color="rgb(234, 181, 112)" />, 
    title: "Cybersecurity & System Audits",
    text: "We enhance system security through penetration testing, vulnerability assessment, and implementation of modern cybersecurity best practices."
  },

  { 
    id: 6,
    icon: <LightbulbFill size={24} color="rgb(234, 181, 112)" />, 
    title: "IT Consultancy & System Design",
    text: "We help businesses design efficient digital systems, recommend the right technologies, and guide you through digital transformation."
  }
];


function About() {
  return (
    <div className="container px-4 py-5" id="icon-grid">
      <h2 className="about-h2 pb-3 border-bottom"style={{color:"rgb(165, 209, 247)"}}>About us</h2>
      <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-5 py-5 mx-auto">
        {icons.map((item) => (
          <div key={item.id} className="col align-items-center" >

             <div className="mb-4">{item.icon}</div>
        
            <div>

              <h3 className="fw-bold mb-0 fs-4 text-body-emphasis"style = {{color:"rgb(165, 209, 247)"}}>
              {item.title}</h3>
              <p style={{color:"white",
                fontSize:"1.2rem"
                }}
                >{item.text}
              </p>
            </div>
          </div>
        ))}
      </div>
       <Link to="/Contact">
            <button type="button" className="btn btn-primary btn-lg px-4 me-md-2">
    
              Contacts ➡️
            </button>
             </Link>
    </div>
  );
}




export default About;